import {
	COLOR_BLOCK,
	colorBlockHtml,
} from "@productlane/lib/src/help-center-scrape/mintlify/color-mdx"

import type { MdxBlockReader } from "./registry"

// A row title is one line of markdown, so its paragraph wrapper goes.
const unwrapParagraph = (html: string): string =>
	html
		.trim()
		.replace(/^<p>([\s\S]*)<\/p>$/, "$1")
		.trim()

export const colorReaders: MdxBlockReader[] = [
	{
		name: "color",
		pattern: COLOR_BLOCK,
		render: (match, parseBody) =>
			colorBlockHtml(match[2] ?? "", (markdown) =>
				unwrapParagraph(parseBody(markdown)),
			) ?? "",
	},
]
